import React from "react";
import ButtonNavigatorComponent from "../../../../../../components/ButtonNavigator";
import IconButton from "../../../../../../components/IconButton";
import { TableComponent, TH, THeadTR } from "../../../../../../components/Table v2";
import { IconEye, IconSwitch, IconTrash } from "../../../../../../icons";
import { orderBy } from "../../../../../../libs/orderBy";
import { IEletronicInventory } from "../../Form/models";
import { THEADERMOCK } from "../constants";
import { IListEletronic } from "../models";
import useListEletronicStore from "../store/useStore";

export default function TableEletronics() {
  const { inactiveOrActive, eletronicInactived, eletronicActived, page, selectSize, orderSwitch, totalItens, listEletronic } =
    useListEletronicStore();
  const { setEletronicInactived, setEtronicActived, setOrderSwitch, setPage, setModalStatus, setSelectSize } = useListEletronicStore();

  let total = 0;

  function renderizar() {
    return inactiveOrActive ? eletronicInactived : eletronicActived;
  }

  function listRenderObserverThePage(indexOfLine: number) {
    const initialListRender = indexOfLine < (page + 1) * selectSize;
    const endListRender = indexOfLine >= page * selectSize;
    return initialListRender && endListRender;
  }

  function handleOrderList(label: string) {
    orderSwitch ? setEtronicActived(orderBy(eletronicActived, label, "asc")) : setEtronicActived(orderBy(eletronicActived, label, "desc"));
    orderSwitch
      ? setEletronicInactived(orderBy(eletronicInactived, label, "asc"))
      : setEletronicInactived(orderBy(eletronicInactived, label, "desc"));
    setOrderSwitch((oldState: boolean) => !oldState);
    renderizar();
    setPage(0);
  }

  function totalValue() {
    function whatTotal() {
      return !inactiveOrActive ? totalItens : String(getTotalItensInactives(listEletronic));
    }
    return (
      <>
        <hr />
        <span className="font-source-sans-pro color-text bold">
          total em tela: {total?.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
        </span>
        <span className="font-source-sans-pro color-text bold">
          total: {Number(whatTotal()?.replaceAll(",", "."))?.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
        </span>
      </>
    );
  }

  function getTotalItensInactives(list: IEletronicInventory[]) {
    let total = 0;
    list?.forEach((item) => {
      if (item?.isDeleted) total += +item?.purchasePrice;
    });
    return total;
  }

  return (
    <>
      <TableComponent className="table-container-header-body">
        {!!renderizar()?.length ? (
          <THeadTR>
            {THEADERMOCK?.map((header, index) => {
              return (
                <TH key={index}>
                  <div className="wrapperTheader">
                    <span>{header.name}</span>
                    <IconButton className="center row-trash icon-trash" icon={IconSwitch} onClick={() => handleOrderList(header.value)} />
                  </div>
                </TH>
              );
            })}
            {!!renderizar()?.length && (
              <>
                <TH>Editar</TH>
                <TH>Ações</TH>
              </>
            )}
          </THeadTR>
        ) : (
          <div className="nothing-list flex justify-center width-100">
            <h1>Não há registros para a busca realizada.</h1>
          </div>
        )}
        <tbody>
          {renderizar()?.map((item: IListEletronic, index: number) => {
            return (
              listRenderObserverThePage(index) &&
              ((total += Number(item?.purchasePrice)),
              (
                <tr key={item?.id}>
                  <td className="cursor-pointer">{item?.nameProduct}</td>
                  <td>{item?.assetNumber}</td>
                  <td>{item?.serialNumber}</td>
                  <td>{item?.status}</td>
                  <td>{item?.userName}</td>
                  <td>{item?.statementOfResponsibility ? "Sim" : "Não"}</td>
                  <td>{Number(item?.purchasePrice).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</td>
                  <td className="col-function">
                    <IconButton className="center row-edit" icon={IconEye} url={`/eletronic-inventory/form/${item?.id}`} />{" "}
                  </td>
                  <td className="row-trash">
                    <IconButton
                      className="center row-trash icon-trash"
                      onClick={() => setModalStatus({ status: true, id: Number(item?.id) })}
                      icon={IconTrash}
                    />{" "}
                  </td>
                </tr>
              ))
            );
          })}
        </tbody>
      </TableComponent>
      {renderizar()?.length ? (
        <ButtonNavigatorComponent
          className="width-select-size"
          list={renderizar()}
          page={page}
          setPage={setPage}
          selectSize={selectSize}
          setSelectSize={setSelectSize}
          ExtraContent={() => totalValue()}
        />
      ) : (
        ""
      )}
    </>
  );
}
